var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "instant_mix"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1187_1290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 22,
    height: 21,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1187_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "instant_mix_2",
    d: "M2.44444 21.592V12.1455H0V9.44651H7.33333V12.1455H4.88889V21.592H2.44444ZM2.44444 6.74751V0H4.88889V6.74751H2.44444ZM7.33333 6.74751V4.0485H9.77778V0H12.2222V4.0485H14.6667V6.74751H7.33333ZM9.77778 21.592V9.44651H12.2222V21.592H9.77778ZM17.1111 21.592V17.5435H14.6667V14.8445H22V17.5435H19.5556V21.592H17.1111ZM17.1111 12.1455V0H19.5556V12.1455H17.1111Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0a494c6ef7321add4c8049bdfaf78166.svg";
export { ForwardRef as ReactComponent };